<div #contentWrapper>
  <ng-content></ng-content>
</div>

<div #repeatContainer [class]="ContainerClass"></div>
